<template>
  <section id="about" class="n2-seccion n5-notario" v-if="PN?.Mostrar">
    <div class="n2-contenedor">
      <div class="n5-notario__rejilla" :class="{ 'n5-notario__rejilla--invertida': PN.ImageLeft === false }">
        <figure v-if="PN.Imagen" class="n5-notario__foto n2-aparece">
          <img :src="imagenIDtoSRC(PN.Imagen)" :alt="'Fotografía de ' + NOTARIA.Nombre + ' - Notario'" loading="lazy" />
        </figure>
        <div class="n2-aparece">
          <span v-if="etiqueta" class="n5-etiqueta">{{ etiqueta }}</span>
          <h2 class="n5-titulo" v-html="PN.Titulo?.Texto || etiquetaPorDefecto"></h2>
          <div v-if="PN.Descripcion?.Texto" class="n2-texto-rico" :style="alineacionTexto(PN.Descripcion.css)" v-html="PN.Descripcion.Texto"></div>
          <NuxtLink v-if="NOTARIA.Theme.Menu?.ShowNotarios && NOTARIA.Notarios?.length" :to="getLocalePath('/notarios')" class="n2-enlace">
            {{ etiquetaPorDefecto }} <span aria-hidden="true">→</span>
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, alineacionTexto } from '../../composables/useNotaria2'
import { etiquetaSeccion } from '../../composables/useNotaria5'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
// Panel: Inicio → Palabras del notario
const PN = computed(() => NOTARIA.value?.Theme?.Home?.PN)
const etiquetaPorDefecto = computed(() => tituloSeccion(NOTARIA.value, 'Notario', $t))
const etiqueta = computed(() => etiquetaSeccion(PN.value?.Titulo?.Texto, etiquetaPorDefecto.value))
</script>
